import { Grid, ListItem, Switch, Typography } from '@mui/material';
import React from 'react';
import { Locale } from '../../translations/translations';

interface HeaderHandleLanguageProps {
    language: Locale;
    selectLanguage: (language: Locale) => void;
}

export const HeaderHandleLanguage: React.FC<HeaderHandleLanguageProps> = ({ language, selectLanguage }) => {
    const [checked, setChecked] = React.useState(language !== 'EN');

    const handleChange = () => {
        setChecked(!checked);
        return selectLanguage(checked ? 'EN' : 'FR');
    };

    return (
        <ListItem component={Grid} item container direction="row" wrap="nowrap" alignItems="center" width="100%">
            <Typography>EN</Typography>
            <Switch
                color="default"
                checked={checked}
                onClick={handleChange}
                name="language"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
            <Typography>FR</Typography>
        </ListItem>
    );
};
